// This file dynamically loads Adobe Launch properties.

// Off-Platform (N-ACDL) property URLs should be provided as env vars.
const OFF_PLATFORM_PRODUCTION_SCRIPT =
  process.env.OFF_PLATFORM_LAUNCH_PRODUCTION ||
  'https://assets.adobedtm.com/697d0c070f1e/ea551cf1cad8/launch-5d99fead16ce.min.js';
const OFF_PLATFORM_NON_PRODUCTION_SCRIPT =
  process.env.OFF_PLATFORM_LAUNCH_NON_PRODUCTION ||
  'https://assets.adobedtm.com/697d0c070f1e/ea551cf1cad8/launch-eb6ceb729916-staging.min.js';

const isProduction = process.env.IS_PRODUCTION === 'true';
const isLocalhost =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const loadLaunchOnLocalhost = process.env.LOAD_ADOBE_LAUNCH_ON_LOCALHOST === 'true';

const loadLaunchScript = (url, label) => {
  if (!url) {
    if (!isProduction) {
      console.warn(`Skipped Adobe Launch script for ${label} (no URL configured).`);
    }
    return;
  }

  if (document.querySelector(`script[src="${url}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  script.onerror = () => {
    console.error(`Failed to load Adobe Launch script for ${label} - ${url}`);
  };
  document.head.appendChild(script);

  if (!isProduction) {
    console.log(`Loaded Adobe Launch script for ${label} - ${url}`);
  }
};

if (isLocalhost && !loadLaunchOnLocalhost) {
  console.info(
    'Skipping Adobe Launch on localhost. Set LOAD_ADOBE_LAUNCH_ON_LOCALHOST=true to enable local Launch testing.'
  );
} else {
  loadLaunchScript(
    isProduction ? OFF_PLATFORM_PRODUCTION_SCRIPT : OFF_PLATFORM_NON_PRODUCTION_SCRIPT,
    `Off-Platform N-ACDL (${isProduction ? 'production' : 'non-production'})`
  );
}
